import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaLink } from 'react-icons/fa';
import AddressSheet from '../../../orders/OrderConfirm/AddressSheet';
import '../../../orders/OrderConfirm/checkout-theme.css';
import ListReceiveAddress from './ListReceiveAddress';
import FormReceiveAddress from './FormReceiveAddress';
import _ from "lodash";
import { formatDeliveryAddress } from '../../../../helpers';

const ReceiveDeliveryAddress = ({ userAddress, setIsReceiveData, receiveData, userConfirm, psid, orderGroup, selectedDelivery, fetchUserAddressData, onUseManualAddress }) => {
    const [isAddModal, setIsAddModal] = useState(false);
    // ໃນ sheet ລູກຄ້າລຶບ ຫຼື ແກ້ທີ່ຢູ່ໄດ້ ແຕ່ ListReceiveAddress ດຶງໃໝ່ສະເພາະລາຍການຂອງມັນເອງ
    // ບໍ່ດຶງຂອງ parent ນຳ — card ຈຶ່ງຄ້າງທີ່ຢູ່ທີ່ລຶບໄປແລ້ວ ແລະ isReceiveData ຍັງຊີ້ໃສ່ record ນັ້ນ
    // ຕອນຢືນຢັນອໍເດີ. ດຶງໃໝ່ຕອນປິດ sheet ຈຶ່ງກັບມາກົງກັນ
    const onCloseModalAdd = () => {
        setIsAddModal(false);
        if (fetchUserAddressData) fetchUserAddressData();
    };

    // CHECK USER ADDRESS
    const [idSelect, setIdSelect] = useState('');
    const [isSelect, setIsSelect] = useState(false);
    const [isDataSelect, setIsDataSelect] = useState({});
    // ໜ້າ checkout ສະຫຼັບໄປໂໝດ "ພິມທີ່ຢູ່ເອງ" ແລ້ວກັບມາ = component ນີ້ຖືກ mount ໃໝ່
    // state ພາຍໃນຫາຍໝົດ ຖ້າເລີ່ມຈາກ {} effect ຂ້າງລຸ່ມຈະດີດໄປອັນທຳອິດ ແລ້ວທັບ
    // ທີ່ຢູ່ທີ່ລູກຄ້າເລືອກໄວ້ໃນ parent — ຮັບຄ່າຈາກ parent ມາເປັນຄ່າຕັ້ງຕົ້ນຈຶ່ງບໍ່ລືມ
    // (optional prop — ບ່ອນທີ່ບໍ່ໄດ້ສົ່ງມາຍັງເປັນ {} ຄືເກົ່າ)
    const [isUserAddress, setIsUserAddress] = useState(() => receiveData ?? {});

    // ลูกค้าเลือกขนส่งไว้แล้วจาก dropdown — เหลือเฉพาะที่อยู่ของขนส่งนั้น
    // ไม่ได้เลือก (ค่าว่าง) ให้แสดงทั้งหมดเหมือนเดิม
    const filteredAddress = _.isEmpty(selectedDelivery)
        ? userAddress
        : userAddress.filter((address) => address?.deliveryName === selectedDelivery);

    useEffect(() => {
        // ໃຊ້ຮູບແບບ callback ບໍ່ແມ່ນອ່ານ isUserAddress ໂດຍກົງ — ຈະໄດ້ບໍ່ຕ້ອງໃສ່ມັນໃນ dep ແລ້ວວົນ
        setIsUserAddress((prev) => {
            // ທີ່ຢູ່ທີ່ລູກຄ້າເລືອກເອງຕ້ອງຢູ່ຄືເກົ່າ
            //
            // ຕອນປິດ sheet ເຮົາດຶງລາຍການໃໝ່ (ກັນ card ຄ້າງທີ່ຢູ່ທີ່ຖືກລຶບ) ເຊິ່ງເຮັດໃຫ້
            // reference ຂອງ userAddress ປ່ຽນ. ຂອງເກົ່າຈະດີດກັບໄປອັນ default ທຸກເທື່ອ
            // ຜົນຄື ລູກຄ້າເລືອກທີ່ຢູ່ອື່ນແລ້ວກັບອອກມາ card ຍັງເປັນອັນເກົ່າ
            const _still = filteredAddress.find((item) => item?.id === prev?.id);
            if (_still) return _still;

            // ບໍ່ມີອັນທີ່ເລືອກໄວ້ແລ້ວ (ຫາກໍເພີ່ມໃໝ່ ຫຼື ອັນເກົ່າຖືກລຶບ) — ເອົາອັນລ່າສຸດ
            //
            // ຂອງເກົ່າເອົາອັນ default === true ກ່ອນ. ແຕ່ໜ້ານີ້ຕັ້ງ default ບໍ່ໄດ້ເລີຍ
            // (ປຸ່ມນັ້ນຖືກ comment ໄວ້) ມັນເປັນຂໍ້ມູນຄ້າງມາຈາກລະບົບອື່ນ ຜົນຄື
            // ລູກຄ້າເພີ່ມທີ່ຢູ່ຂົນສົ່ງໃໝ່ແລ້ວ card ຍັງກັບໄປອັນເກົ່າທີ່ຕິດ default ຢູ່
            // backend ຮຽງ updatedAt DESC ມາໃຫ້ ອັນທີ່ຫາກໍບັນທຶກຈຶ່ງຢູ່ຫົວແຖວ
            return filteredAddress[0] ?? {};
        });
    }, [userAddress, selectedDelivery]);

    useEffect(() => {
        setIsReceiveData(isUserAddress);
        setIdSelect(isUserAddress?.id);
    }, [isUserAddress]);

    useEffect(() => {
        if (isSelect) {
            setIsReceiveData(isDataSelect);
            setIsUserAddress(isDataSelect);
            setIsSelect(false);
        }
    }, [isDataSelect]);

    const newAddress = (value) => formatDeliveryAddress(value) || "ບໍ່ພົບຂໍ້ມູນທີ່ຢູ່";

    return (
        <>
            {/* มีที่อยู่อยู่แล้ว แต่ไม่มีของขนส่งที่เพิ่งเลือก — ต้องมีทางสร้างใหม่ ไม่งั้นตัน */}
            {_.isEmpty(isUserAddress) && !_.isEmpty(selectedDelivery) &&
                // ມີທີ່ຢູ່ຂອງເຈົ້າອື່ນຢູ່ ແຕ່ບໍ່ມີຂອງເຈົ້າທີ່ຫາກໍເລືອກ
                // ສະແດງຟອມສ້າງທີ່ຢູ່ໃຫ້ເລີຍ ແບບດຽວກັບຕອນທີ່ຍັງບໍ່ມີທີ່ຢູ່ເລີຍ (ShopInfoOrderConfirm)
                // ບໍ່ໃຊ້ປຸ່ມເປີດ popup ເພາະລູກຄ້າຍັງໄງກໍຕ້ອງສ້າງຢູ່ດີ
                <div className="cf-card">
                    <div className="mb-3 text-center fw-bold" style={{ color: '#dc3545' }}>
                        ***** ກະລຸນາສ້າງທີ່ຢູ່ສຳລັບຂົນສົ່ງນີ້! *****
                    </div>
                    <FormReceiveAddress
                        userConfirm={userConfirm}
                        psid={psid}
                        onCloseModalAdd={onCloseModalAdd}
                        fetchUserAddressData={fetchUserAddressData}
                        orderData={orderGroup}
                        selectedDelivery={selectedDelivery}
                        onUseManualAddress={onUseManualAddress}
                    />
                </div>
            }
            {!_.isEmpty(isUserAddress) &&
                <div className="cf-addr">
                    {isUserAddress?.deliveryName === "OF_POINT" ? (
                        <FaMapMarkerAlt className="cf-addr__pin" aria-hidden="true" />
                    ) : (
                        <img
                            className="cf-addr__logo"
                            src={isUserAddress?.img || undefined}
                            // ຊື່ຂົນສົ່ງບໍ່ໄດ້ຂຽນເປັນຕົວໜັງສືບ່ອນໃດໃນ card ນີ້ — alt ຈຶ່ງຫວ່າງບໍ່ໄດ້
                            alt={isUserAddress?.deliveryName || ""}
                            width={36}
                            height={36}
                        />
                    )}

                    <div className="cf-addr__text">
                        {isUserAddress?.deliveryName === "OF_POINT" && (
                            <div className="cf-addr__meta">ຮັບເຄື່ອງໜ້າຮ້ານ</div>
                        )}
                        <div className="cf-addr__name">{`${isUserAddress?.userName} (+856) ${isUserAddress?.userTel}`}</div>
                        <div className="cf-addr__meta">{newAddress(isUserAddress)}</div>
                    </div>

                    <div className="cf-addr__actions cf-addr__actions--row">
                        {isUserAddress?.latLong && (
                            // ເມື່ອກ່ອນເປັນ <a> ຢູ່ໃນ <Button> — ຊ້ອນປຸ່ມໃນປຸ່ມ screen reader ອ່ານບໍ່ຖືກ
                            <a
                                className="cf-icon-btn"
                                href={isUserAddress?.latLong}
                                target="google_map"
                                rel="noreferrer"
                                aria-label="ເປີດແຜນທີ່"
                            >
                                <FaLink aria-hidden="true" />
                            </a>
                        )}
                        <button
                            type="button"
                            className="cf-link-btn cf-link-btn--sm"
                            onClick={() => setIsAddModal(true)}
                        >
                            ແກ້ໄຂ
                        </button>
                    </div>
                </div>
            }

            {/* ໜ້າເຕັມຈໍແບບດຽວກັບ "ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ" — ບໍ່ໃຊ້ popup ນ້ອຍໆອີກແລ້ວ */}
            <AddressSheet
                open={isAddModal}
                title="ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ"
                onClose={onCloseModalAdd}
            >
                <ListReceiveAddress userId={isUserAddress?.user ?? userConfirm?.id} userConfirm={userConfirm} psid={psid}
                    idSelect={idSelect} setIdSelect={setIdSelect}
                    onClose={onCloseModalAdd}
                    setIsDataSelect={setIsDataSelect}
                    setIsSelect={setIsSelect}
                    orderGroup={orderGroup}
                    selectedDelivery={selectedDelivery}
                    // ປິດ sheet ລາຍການທີ່ຢູ່ ແລ້ວປ່ອຍໃຫ້ໜ້າ checkout ສະຫຼັບເປັນໂໝດພິມເອງ
                    // ບໍ່ຜ່ານ onCloseModalAdd ເພາະບໍ່ຢາກໃຫ້ດຶງລາຍການໃໝ່ຕອນກຳລັງອອກຈາກໜ້ານີ້
                    onUseManualAddress={onUseManualAddress ? () => {
                        setIsAddModal(false);
                        onUseManualAddress();
                    } : undefined}
                />
            </AddressSheet>
        </>
    );
};

export default ReceiveDeliveryAddress;
